/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
  setFromAndTo,
  setType,
  setEnabled,
  setIsInitialized,
  clear
} = createActions(
	{
    SET_FROM_AND_TO: ({ from, to }) => ({ from, to }),
    SET_TYPE: (type) => ({ type }),
    SET_ENABLED: (enabled) => ({ enabled }),
    SET_IS_INITIALIZED: (isInitialized) => ({ isInitialized }),
    CLEAR: () => ({})
	},
	{ prefix: ROOT_SLICE }
);

export { setType, setFromAndTo, setEnabled, setIsInitialized, clear };

export default { setType, setFromAndTo, setEnabled, setIsInitialized, clear };
